import React, {useMemo, useState} from "react";
import dayjs from "dayjs";
import {addMonths} from "date-fns";
import {toKSTISOString, toKSTISOStringEnd} from "../../components/commonmethod/CommonMethod";

const PERIOD_PRESETS = [
    {key: "1m", label: "1개월", months: -1},
    {key: "3m", label: "3개월", months: -3},
    {key: "6m", label: "6개월", months: -6},
    {key: "1y", label: "1년", months: -12},
];

function isSameDay(a, b) {
    if (!a || !b) return false;
    return dayjs(a).format("YYYY-MM-DD") === dayjs(b).format("YYYY-MM-DD");
}

function detectPreset(date) {
    const today = dayjs().endOf("day");
    if (!isSameDay(date.endDate, today.toISOString())) return "3m";

    for (const preset of PERIOD_PRESETS) {
        const expectedStart = toKSTISOString(addMonths(new Date(), preset.months));
        if (isSameDay(date.startDate, expectedStart)) return preset.key;
    }
    return "3m";
}

function StaticDateRangeFilter({date, onChange}) {
    const [activePreset, setActivePreset] = useState(() => detectPreset(date));

    const resolvedPreset = useMemo(() => activePreset ?? detectPreset(date), [activePreset, date]);

    const applyPreset = (preset) => {
        const nextDate = {
            startDate: toKSTISOString(addMonths(new Date(), preset.months)),
            endDate: toKSTISOStringEnd(new Date()),
        };
        setActivePreset(preset.key);
        onChange(nextDate);
    };

    return (
        <div className="flex h-full items-center justify-end">
            <div className="flex items-center gap-[2px] rounded-[6px] border border-[#e2e8f0] bg-[#f8fafc] p-[3px]">
                {PERIOD_PRESETS.map((preset) => {
                    const isActive = resolvedPreset === preset.key;
                    return (
                        <button
                            key={preset.key}
                            type="button"
                            onClick={() => applyPreset(preset)}
                            className={[
                                "rounded-[4px] px-[10px] py-[5px] text-[12px] font-medium leading-none transition-colors",
                                isActive
                                    ? "bg-white text-[#1c90fb] shadow-[0_1px_2px_rgba(0,0,0,0.06)]"
                                    : "text-[#64748b] hover:bg-white/70 hover:text-[#334155]",
                            ].join(" ")}
                        >
                            {preset.label}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}

export default StaticDateRangeFilter;
